import React, { Component } from 'react';
import PropTypes from 'prop-types';

const inContestTag = {
  id: 0,
  tag: 'Участвует в конкурсе',
  alias: 'in-contest'
};

export default class TagsDesktop extends Component {
  static propTypes = {
    onChangeTags: PropTypes.func.isRequired,
    selectedTags: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.tagsLines = 1;
    this.state = {
      collapsed: true
    };
  }

  openTag = (tag) => {
    if (this.props.selectedTags.indexOf(tag) == -1) {
      this.props.onChangeTags([...this.props.selectedTags, tag]);
    }
  };

  closeTag = (tag) => {
    const selected = this.props.selectedTags.filter(x => x !== tag);
    this.props.onChangeTags(selected);
  };

  isActive = (alias) => {
    const selectedTags = this.props.selectedTags;
    const isActive = selectedTags.some(currentValue => currentValue === alias);
    return isActive;
  };

  getTagHeight = (el) => {
    const styles = window.getComputedStyle(el);
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    return el.offsetHeight ? Math.ceil(el.offsetHeight + margin) : 0;
  };

  toggleTags = () => {
    this.setState(state => ({
      collapsed: !state.collapsed
    }));
  };

  addActiveClass = alias => `tags-item ${this.isActive(alias) ? '-active' : ''}`;

  render() {
    const { tags } = this.props;
    const { collapsed } = this.state;
    const tagsItemHeight = this.tagsItem && this.getTagHeight(this.tagsItem);
    const maxTagsItemHeight = tagsItemHeight * this.tagsLines;
    const tagsWrapperHeight = this.tagsWrapper && this.tagsWrapper.scrollHeight;
    const showExpandButton = tagsWrapperHeight > maxTagsItemHeight;
    return (
      <div className="box-row box-row--tags">
        <div
          className="tags"
          ref={el => (this.tagsWrapper = el)}
          style={{ maxHeight: collapsed && maxTagsItemHeight ? `${maxTagsItemHeight}px` : 'none' }}
        >
          <button
            className={this.addActiveClass(inContestTag.alias)}
            onClick={() => this.openTag(inContestTag.alias)}
            ref={el => (this.tagsItem = el)}
          >
            {inContestTag.tag}
            {this.isActive(inContestTag.alias) && (
              <button
                className="tags-item-deactivate"
                onClick={() => this.closeTag(inContestTag.alias)}
              >
                {'Отменить'}
              </button>
            )}
          </button>
          {tags.map(item => (
            <button
              key={item.id}
              className={this.addActiveClass(item.alias)}
              onClick={() => this.openTag(item.alias)}
            >
              {item.tag}
              {this.isActive(item.alias) && (
                <button className="tags-item-deactivate" onClick={() => this.closeTag(item.alias)}>
                  {'Отменить'}
                </button>
              )}
            </button>
          ))}
        </div>
        {showExpandButton && (
          <button className="btn -more tags__more" onClick={this.toggleTags}>
            {collapsed ? 'Еще' : 'Скрыть'}
          </button>
        )}
      </div>
    );
  }
}
